import { render } from "./SchemaSnapshotManage.vue?vue&type=template&id=14f54ed7"
import script from "./SchemaSnapshotManage.vue?vue&type=script&lang=js"
export * from "./SchemaSnapshotManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__